import { mergeRoomPolygons } from "../../polygonMerge";
import type { GetMergedRoomOutline } from "./types";

// The rooms kept whole, the walls between them filled, the rest bridged; see mergeRoomPolygons.
export const getMergedRoomOutline: GetMergedRoomOutline = ({
  rooms,
  roomIds,
  wallWidthPt,
}) => {
  const mergedRoomIds = new Set(roomIds);
  const rings = rooms
    .filter((room) => mergedRoomIds.has(room.id))
    .map((room) => room.points);

  return mergeRoomPolygons({ rings, wallWidthPt });
};
